<div class="modal-wrap">
    <div class="closing-x-wrap">
        <mat-icon (click)="closeModal()" class="close-icon">close</mat-icon>
    </div>

    <div mat-dialog-content [innerHTML]="systemMessageData.messageHTML" class="doc-container"></div>
    <div [ngStyle]="{ 'background-color': systemMessageData.systemMessageColor }" class="color-identifier"></div>
</div>
